const convertLegacyOrderState = (orderState, results) => {
  switch (orderState) {
    case 'pending': // Back-end
      return 'IN_PROGRESS'
    case 'success': // Back-end
      return 'COMPLETED'
    case 'CANCELLED': // Back-end
      return 'CANCELLED'
    case 'failed': // Back-end
      return 'FAILED'
    default:
      return 'FAILED_TO_CONVERT_ORDER_STATE: ' + orderState
  }
}

export {
  convertLegacyOrderState
}



// WEBPACK FOOTER //
// ./src/utils/legacyOrderPaymentStatus.js